<template>
    <b-modal id="defaultModal" hide-footer centered>
        <UpdateSubCategory v-if="action.action === 'updateScat'" :action="action"> </UpdateSubCategory>

        <CreateCategory v-if="action.action === 'addCategory'" :action="action"> </CreateCategory>

        <CreateSubCategory v-if="action.action === 'addSubcat'" :action="action"> </CreateSubCategory>

        <DeleteCategory v-if="action.action === 'deleteCat'" :action="action"> </DeleteCategory>

        <DeleteSubCategory v-if="action.action === 'deleteSubCat'" :action="action"> </DeleteSubCategory>
    </b-modal>
</template>

<script>
import UpdateSubCategory from "../actions/UpdateSubCategory";
import CreateCategory from "../actions/CreateCategory";
import CreateSubCategory from "../actions/CreateSubCategory";
import DeleteCategory from "../actions/DeleteCategory";
import DeleteSubCategory from "../actions/DeleteSubCategory";

export default {
    props: ["action"],
    data() {
        return {};
    },
    components: {
        UpdateSubCategory,
        CreateCategory,
        CreateSubCategory,
        DeleteCategory,
        DeleteSubCategory
    },
    watch: {},
    mounted() {},
    methods: {},
    computed: {},
    created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Modal.vue?29c753a8